import React from "react";
import { Link, useParams } from "react-router-dom";
import { Button } from "../components/ui/button";
import ProductRow from "../components/ProductRow";
import { INDUSTRIES, productsForIndustry } from "../mock/mock";

export default function IndustryPage({ onEnquire }) {
  const { slug } = useParams();
  const industry = INDUSTRIES.find((i) => i.slug === slug) || INDUSTRIES[0];
  const products = productsForIndustry(industry.slug);

  return (
    <div className="bg-white">
      {/* Header */}
      <section className="bg-[#f7f9fc] py-8 md:py-10">
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <nav className="flex items-center gap-2 text-[13px] text-slate-500 mb-5">
            <Link to="/" className="hover:text-[#1c2e3a]">Home</Link>
            <span>&gt;</span>
            <Link to="/industries" className="hover:text-[#1c2e3a]">Industries</Link>
            <span>&gt;</span>
            <span className="text-[#1c2e3a] font-medium">{industry.title}</span>
          </nav>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <p className="text-[12px] font-semibold tracking-[0.25em] text-[#f4520b] mb-3">INDUSTRY CATALOG</p>
              <h1 className="font-heading text-3xl md:text-4xl font-extrabold text-[#1c2e3a]">{industry.title}</h1>
              <p className="mt-3 text-slate-600 leading-relaxed max-w-xl">{industry.tagline}</p>
            </div>
            <img src={industry.image} alt={industry.title} className="w-full rounded-xl shadow-lg object-cover aspect-[16/8] hidden lg:block" />
          </div>
        </div>
      </section>

      {/* Product list */}
      <section className="py-10 md:py-12">
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <p className="text-sm text-slate-500 mb-5">
            Showing <span className="font-semibold text-[#1c2e3a]">{products.length}</span> products · prices shown are starting prices per unit
          </p>
          <div className="space-y-4">
            {products.map((p) => (
              <ProductRow key={p.id} product={p} onEnquire={onEnquire} />
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="pb-14">
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <div className="rounded-2xl bg-[#fff0e9] text-center py-12 px-6">
            <h3 className="font-heading text-2xl md:text-3xl font-extrabold text-[#1c2e3a]">Need a Custom Solution for {industry.title}?</h3>
            <p className="mt-3 text-slate-600 max-w-xl mx-auto">Custom sizes, firmness, covers and packaging - our team will help you with the right specifications for your project.</p>
            <Button onClick={() => onEnquire()} className="mt-6 bg-[#1c2e3a] hover:bg-[#29424f] text-white rounded-md px-8 h-12 font-semibold">
              Get in Touch
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
}
